import React from 'react';
import type { CriterionLevel, DevStage } from '../../types/developmentDemo';
import { criterionLevelLabels } from '../../data/developmentDomains';
import { stageLabels } from '../../utils/developmentDemo';
const stageStyles: Record<DevStage, string> = {
  'ready-initial': 'border-line bg-white text-ink-muted',
  'awaiting-review': 'border-lavender/30 bg-lavender-pale text-lavender',
  revision: 'border-amber-300 bg-amber-50 text-amber-900',
  'awaiting-activity': 'border-lavender/30 bg-lavender-pale text-lavender',
  practising: 'border-navy/20 bg-surface-muted text-navy',
  'ready-reassessment': 'border-teal/30 bg-teal-pale text-navy',
  'cycle-complete': 'border-teal/30 bg-teal-pale text-navy'
};
export function StageBadge({
  stage
}: {
  stage: DevStage;
}) {
  return <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap ${stageStyles[stage]}`} data-id="element-584" data-mp="39kpyboromcos">
      {stageLabels[stage].label}
    </span>;
}
const levelStyles: Record<CriterionLevel, {
  className: string;
  filled: number;
}> = {
  'not-yet': {
    className: 'text-ink-muted',
    filled: 0
  },
  partly: {
    className: 'text-navy',
    filled: 1
  },
  evidenced: {
    className: 'text-navy',
    filled: 2
  }
};

/** Shows what a single task evidenced for one criterion — not a score. */
export function LevelBadge({
  level
}: {
  level: CriterionLevel;
}) {
  const style = levelStyles[level];
  return <span className={`inline-flex items-center gap-2 text-sm font-semibold ${style.className}`} data-id="element-585" data-mp="jt82mfo9nbdj">
      <span aria-hidden="true" className="flex gap-0.5" data-id="element-586" data-mp="osca91vjl11r">
        {[0, 1].map(index => <span key={index} className={`h-2.5 w-2.5 rounded-full border ${index < style.filled ? 'border-lavender bg-lavender' : 'border-ink-muted/40 bg-white'}`} data-id="element-587" data-mp="tq4bwnlzo1j5" />)}
      </span>
      {criterionLevelLabels[level]}
    </span>;
}